import "./CSS/buttons.css";
import "./CSS/checkInTrailer.css";
import "./CSS/edit-page.css";
import "./CSS/checkInTrailer.css";
import "./CSS/driver.css";
import "./CSS/edit-page.css";
import "./CSS/errorPage.css";
import "./CSS/fancyDropDown.css";
import "./CSS/global.css";
import "./CSS/guardOverview.css";
import "./CSS/idCard.css";
import "./CSS/imageModal.css";
import "./CSS/inputs.css";
import "./CSS/loadingAnimations.css";
import "./CSS/login.css";
import "./CSS/navbar.css";
import "./CSS/profileSettings.css";
import "./CSS/report.css";
import "./CSS/reservations.css";
import "./CSS/yardTable.css";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Login } from "./Routes/Login";
import { Logout } from "./Routes/Logout";
import {
  faChevronDown,
  faDownload,
  faEnvelope,
  faLock,
  faMagnifyingGlass,
} from "@fortawesome/free-solid-svg-icons";
import ReservationsView from "./Routes/Reservations/Reservations";
import SettingsView from "./Routes/Settings/SettingsView";
import { CheckOut } from "./Routes/CheckOut/CheckOut";
import { ForgotPassword } from "./Routes/ForgotPassword";
import { ErrorPage } from "./Routes/ErrorPage";
import Unauthorized from "./Routes/Unauthorized";

import { AuthProvider } from "./Auth/AuthProvider";
import { ProtectedRoute } from "./Auth/RouteProtector";
import { Navigation } from "./Components/Navigation/Navigation";
import CheckInView from "./Routes/CheckIn/CheckInView";
import { library } from "@fortawesome/fontawesome-svg-core";
import { Suspense } from "react";
import MaintenanceReportsRoute from "./Routes/MaintenanceReports/maintenance-reports";

import { OverviewRefactor } from "./Routes/Home/OverviewRefactor";
import { NewSideBar2 } from "./Components/Navigation/NewSidebar";
import MaintenanceReportView from "./Routes/MaintenanceReports/MaintenanceReportView";
import CTPATView from "./Routes/CTPAT/CTPATView";
import InventoryView from "./Routes/MaintenanceInventory/InventoryView";
import BacklogView from "./Routes/Backlog/BacklogView";
import ExportJobsView from "./Routes/ExportJobsView";
import SetPasswordRoute from "./Routes/SetPassword/set-password";
import PendingTasksView from "./Routes/PendingTasks/PendingTasksView";
import LocationsRoute from "./Routes/Locations/locations";
import LocationRoute from "./Routes/Locations/location";
import TaskBoardView from "./Routes/TaskBoard/TaskBoardView";
import StockLogsView from "./Routes/StockLogs/StockLogsView";
import SuppliersRoute from "./Routes/Suppliers/suppliers";
import SupplierRoute from "./Routes/Suppliers/supplier";
import TasksHistoryView from "./Routes/TaskHistory/TasksHistoryView";
import SealsView from "./Routes/Seals/SealsView";
import EmployeesView from "./Routes/Employees/EmployeesView";
import ReceiptsView from "./Routes/Receipts/ReceiptsView";
import ReceiptIdView from "./Routes/Receipts/ReceiptIdView";
import TrailerAssetsRoute from "./Routes/TrailerAssets/trailer-assets";
import TrailerAssetRoute from "./Routes/TrailerAssets/trailer-asset";
import UsersRoute from "./Routes/Users/users";
import UserRoute from "./Routes/Users/user";
import { ToastProvider } from "./Components/ui/toast/toast";
import InvoicesRoute from "./Routes/Invoices/invoices";
import UserCreateRoute from "./Routes/Users/user-create";
import CreateMaintenanceReportRoute from "./Routes/MaintenanceReports/create-maintenance-report";

library.add(faChevronDown, faEnvelope, faLock, faMagnifyingGlass, faDownload);

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={null}>
        <AuthProvider>
          <div className="App">
            {/* <HelpContainer /> */}

            <Navigation></Navigation>
            <NewSideBar2></NewSideBar2>
            <ToastProvider>
              <Routes>
                {/* unprotected routes */}
                <Route path="*" element={<ErrorPage />} />
                <Route path="/login" element={<Login />} />
                <Route path="/logout" element={<Logout />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/unauthorized" element={<Unauthorized />} />
                <Route
                  path="/setup-password/:uidb64/:token"
                  element={<SetPasswordRoute />}
                />
                {/* Guard Routes */}
                <Route
                  element={
                    <ProtectedRoute
                      allowedRoles={[
                        "Admin",
                        "Guard",
                        "Guard Supervisor",
                        "Safety",
                      ]}
                    />
                  }
                >
                  <Route path="/check-in-trailer" element={<CheckInView />} />
                  <Route path="/check-out" element={<CheckOut />} />
                </Route>

                {/* Shared inventory Guard and Dispatch */}
                <Route
                  element={
                    <ProtectedRoute
                      allowedRoles={[
                        "Admin",
                        "Guard",
                        "Guard Supervisor",
                        "Dispatch",
                        "Safety",
                        "Mechanic",
                        "NewMechanic",
                        "Maintenance",
                      ]}
                    />
                  }
                >
                  <Route path="/" element={<OverviewRefactor />} />
                </Route>
                <Route
                  element={
                    <ProtectedRoute
                      allowedRoles={[
                        "Admin",
                        "Guard",
                        "Guard Supervisor",
                        "Dispatch",
                        "Night Dispatch",
                        "Safety",
                        "Mechanic",
                        "Maintenance",
                      ]}
                    />
                  }
                >
                  <Route path="/settings" element={<SettingsView />} />
                </Route>

                {/* Shared inventory Dispatch and Safety */}

                <Route
                  element={
                    <ProtectedRoute
                      allowedRoles={[
                        "Admin",
                        "Dispatch",
                        "Guard Supervisor",
                        "Safety",
                      ]}
                    />
                  }
                >
                  <Route path="/task-board" element={<TaskBoardView />} />
                  <Route
                    path="/trailer-assets"
                    element={<TrailerAssetsRoute />}
                  />
                  <Route
                    path="/trailer-assets/:id"
                    element={<TrailerAssetRoute />}
                  />
                  <Route path="/backlog" element={<BacklogView />} />
                </Route>

                {/* Shared inventory Guard and Safety */}

                <Route
                  element={
                    <ProtectedRoute
                      allowedRoles={[
                        "Admin",
                        "Guard",
                        "Guard Supervisor",
                        "Safety",
                      ]}
                    />
                  }
                ></Route>
                {/* Mechanic Routes */}
                <Route
                  element={
                    <ProtectedRoute
                      allowedRoles={[
                        "Mechanic",
                        "NewMechanic",
                        "Mechanic Supervisor",
                        "Admin",
                        "Safety",
                        "Dispatch",
                        "Maintenance",
                      ]}
                    />
                  }
                >
                  <Route
                    path="/pending-tasks"
                    element={<PendingTasksView />}
                  ></Route>
                  <Route
                    path="/maintenance-reports"
                    element={<MaintenanceReportsRoute />}
                  />
                  <Route
                    path="/maintenance-reports/:order_number"
                    element={<MaintenanceReportView />}
                  />
                  <Route path="/receipts/:id" element={<ReceiptIdView />} />
                </Route>
                <Route
                  element={
                    <ProtectedRoute
                      allowedRoles={[
                        "Admin",
                        "Safety",
                        "Mechanic Supervisor",
                        "Maintenance",
                        "Mechanic",
                      ]}
                    />
                  }
                ></Route>
                <Route
                  element={
                    <ProtectedRoute
                      allowedRoles={[
                        "Admin",
                        "Mechanic Supervisor",
                        "Safety",
                        "Maintenance",
                      ]}
                    />
                  }
                >
                  <Route path="/suppliers" element={<SuppliersRoute />} />
                  <Route path="/suppliers/:id" element={<SupplierRoute />} />
                  <Route path="/stock-logs" element={<StockLogsView />} />
                  <Route path="/export-jobs" element={<ExportJobsView />} />
                  <Route path="/inventory" element={<InventoryView />} />
                  <Route path="/tasks-history" element={<TasksHistoryView />} />
                  <Route path="/receipts" element={<ReceiptsView />} />
                </Route>
                {/* Dispatch Routes */}
                <Route
                  element={
                    <ProtectedRoute allowedRoles={["Admin", "Dispatch"]} />
                  }
                >
                  <Route path="/reservations" element={<ReservationsView />} />
                </Route>
                {/* Safety Routes */}
                <Route
                  element={
                    <ProtectedRoute allowedRoles={["Admin", "Safety"]} />
                  }
                >
                  <Route path="/task-board" element={<TaskBoardView />} />
                  <Route path="/invoices" element={<InvoicesRoute />} />
                  <Route path="/locations" element={<LocationsRoute />} />
                  <Route path="/locations/:id" element={<LocationRoute />} />
                  <Route path="/ctpat-reports" element={<CTPATView />} />
                  <Route path="/employees" element={<EmployeesView />} />
                </Route>

                {/* Admin Routes */}
                <Route
                  element={
                    <ProtectedRoute
                      allowedRoles={[
                        "Admin",
                        "Guard",
                        "Guard Supervisor",
                        "Dispatch",
                        "Safety",
                      ]}
                    />
                  }
                ></Route>
                <Route
                  element={
                    <ProtectedRoute allowedRoles={["Admin", "Safety"]} />
                  }
                >
                  <Route path="/create-maintenance-report" element={<CreateMaintenanceReportRoute/>}/>
                  <Route path="/seals" element={<SealsView />} />
                </Route>
                <Route element={<ProtectedRoute allowedRoles={["Admin"]} />}>
                  <Route path="/users" element={<UsersRoute />} />
                  <Route path="/users/:id" element={<UserRoute />} />
                  <Route path="/users/create" element={<UserCreateRoute />} />
                </Route>
                <Route
                  element={
                    <ProtectedRoute allowedRoles={["Admin", "Safety"]} />
                  }
                ></Route>
              </Routes>
            </ToastProvider>
          </div>
        </AuthProvider>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
